'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("fieldUtils", function () {
  var inputishSelectorList = ["input", "textarea"];
  var inputishSelector = inputishSelectorList.join(", ");
  var selectishSelectorList = [".tl-select-kind-field", ".tl-select", ".tl-checkbox", ".tl-radio-button", "select", "input[type=checkbox]", "input[type=radio]"];
  var selectishSelector = selectishSelectorList.join(", ");
  function buildOnInputKeypressHandler(handler) {
    return function (event) {
      if (event.which === 13) {
        handler(event);
      }
    };
  }
  var PREVIOUS_VALUE_DATA_KEY = "$fieldPreviousValue";
  function buildOnInputFocusHandler() {
    return function (event) {
      var input = $(event.currentTarget);
      input.data(PREVIOUS_VALUE_DATA_KEY, input.val());
    };
  }
  function buildOnInputBlurHandler(handler) {
    var checkValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return function (event) {
      var input = $(event.currentTarget);
      if (checkValue) {
        var currentVal = input.val();
        var previousVal = input.data(PREVIOUS_VALUE_DATA_KEY);
        if (currentVal !== previousVal) {
          handler(event);
        }
      } else {
        handler(event);
      }
    };
  }
  function buildOnSelectChangeHandler(handler) {
    return function (event) {
      _.defer(function () {
        handler(event);
      });
    };
  }
  return {
    /**
     * Bind given handler to trigger on change of any of given container's children.
     *
     * @returns a unregistration function remove all handlers created heres.
     */
    delegateFieldChange: function delegateFieldChange(container, handler) {
      var inputFocusHandler = buildOnInputFocusHandler();
      var inputKeypressHandler = buildOnInputKeypressHandler(handler);
      var inputBlurHandler = buildOnInputBlurHandler(handler);
      var selectChangeHandler = buildOnSelectChangeHandler(handler);
      container.on("focusin", inputishSelector, inputFocusHandler);
      container.on("keypress", inputishSelector, inputKeypressHandler);
      container.on("focusout", inputishSelector, inputBlurHandler);
      container.on("change", selectishSelector, selectChangeHandler);
      return function () {
        container.off("focusin", inputishSelector, inputFocusHandler);
        container.off("keypress", inputishSelector, inputKeypressHandler);
        container.off("focusout", inputishSelector, inputBlurHandler);
        container.off("change", selectishSelector, selectChangeHandler);
      };
    },
    /**
     * Bind given handler to trigger on leave of any of given container's children.
     *
     * @returns a unregistration function remove all handlers created heres.
     */
    delegateFieldBlur: function delegateFieldBlur(container, handler) {
      var inputBlurHandler = buildOnInputBlurHandler(handler, false);
      var selectChangeHandler = buildOnSelectChangeHandler(handler);
      container.on("change", selectishSelector, selectChangeHandler);
      container.on("focusout", inputishSelector, inputBlurHandler);
      return function () {
        container.off("focusout", inputishSelector, inputBlurHandler);
        container.off("change", selectishSelector, selectChangeHandler);
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/fieldUtils.js
// module id = 2752
// module chunks = 13